/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type SetRootMcpEndpointRequestBody = {
  /**
   * The custom domain whose root mapping to change
   */
  customDomainId: string;
  /**
   * The MCP endpoint to map to the domain root. Omit both ids to clear the mapping.
   */
  mcpEndpointId?: string | undefined;
  /**
   * An MCP server to map to the domain root; its domain endpoint is created when missing. Mutually exclusive with mcp_endpoint_id.
   */
  mcpServerId?: string | undefined;
};

/** @internal */
export type SetRootMcpEndpointRequestBody$Outbound = {
  custom_domain_id: string;
  mcp_endpoint_id?: string | undefined;
  mcp_server_id?: string | undefined;
};

/** @internal */
export const SetRootMcpEndpointRequestBody$outboundSchema: z.ZodMiniType<
  SetRootMcpEndpointRequestBody$Outbound,
  SetRootMcpEndpointRequestBody
> = z.pipe(
  z.object({
    customDomainId: z.string(),
    mcpEndpointId: z.optional(z.string()),
    mcpServerId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      customDomainId: "custom_domain_id",
      mcpEndpointId: "mcp_endpoint_id",
      mcpServerId: "mcp_server_id",
    });
  }),
);

export function setRootMcpEndpointRequestBodyToJSON(
  setRootMcpEndpointRequestBody: SetRootMcpEndpointRequestBody,
): string {
  return JSON.stringify(
    SetRootMcpEndpointRequestBody$outboundSchema.parse(
      setRootMcpEndpointRequestBody,
    ),
  );
}
